import { compareAsc, compareDesc } from 'date-fns';

import { OrderBy } from '../model/order-by.model';
import { ViewTaskItem } from '../model/view-task-item.model';

function sortDate(a: Date | null, b: Date | null, fn: Function): number {
    if (a == null && b != null) {
        return 1;
    }
    if (a != null && b == null) {
        return -1;
    }
    if (a == null && b == null) {
        return 0;
    }
    if (a != null && b != null) {
        return fn(a, b);
    }
}

export function sortItems(
    orderBy: OrderBy,
    items: ViewTaskItem[],
): ViewTaskItem[] {
    switch (orderBy) {
        case OrderBy.DUE_DATE_ASC:
            return [...items].sort((a, b) => {
                let result = sortDate(a.dueDateTime, b.dueDateTime, compareAsc);
                if (result === 0) {
                    result = a.title.localeCompare(b.title);
                }
                return result;
            });
        case OrderBy.DUE_DATE_DESC:
            return [...items].sort((a, b) => {
                let result = sortDate(
                    a.dueDateTime,
                    b.dueDateTime,
                    compareDesc,
                );
                if (result === 0) {
                    result = a.title.localeCompare(b.title);
                }
                return result;
            });
        case OrderBy.CREATION_DATE:
            return [...items].sort((a, b) => {
                let result = compareDesc(a.createdDateTime, b.createdDateTime);
                if (result === 0) {
                    result = a.title.localeCompare(b.title);
                }
                return result;
            });
        case OrderBy.ALPHABETICAL_A_Z:
            return [...items].sort((a, b) => a.title.localeCompare(b.title));
        case OrderBy.ALPHABETICAL_Z_A:
            return [...items].sort((a, b) => b.title.localeCompare(a.title));
        default:
            return items;
    }
}
